import { numberIsFinite } from '../lang';
import logFactory from '../logger';
var log = logFactory('');
export function validateEventValue(maybeValue, method) {
  if (numberIsFinite(maybeValue) || maybeValue == undefined) // eslint-disable-line eqeqeq
    return maybeValue;
  log.error(method + ": value must be a finite number.");
  return false;
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@splitsoftware/splitio/es/utils/inputValidation/eventValue.js
// module id = 2757
// module chunks = 39